import React from 'react'
import { I18n } from '@lingui/react'
import { ActionAddOutline, ActionViewOutline } from '@conserveit/blocks'
import { MetricsType } from '../../../../context/reports/workflow/types'
import * as Sidebar from '../../SideBar.styles'
import { getPersisted, setPersisted } from '../../../../utils/storage'
import { WORKFLOW_PERSIST_KEY, METRICS_TYPE_PERSIST_PROP } from '../../../../context/reports/workflow/constants'

interface Props {
  onMetricsTypeChange: (type: MetricsType) => void
}

const persistConfig = {
  key: WORKFLOW_PERSIST_KEY,
  prop: METRICS_TYPE_PERSIST_PROP
}

export const ActionsBar: React.FC<Props> = ({ onMetricsTypeChange }) => {
  const persistedMetricsType = getPersisted(persistConfig, MetricsType.Completed)

  const [active, setActive] = React.useState(persistedMetricsType)

  const handleSetActive = React.useCallback(function handleSetActive (type: MetricsType, isActive: boolean) {
    return () => {
      if (!isActive) {
        setActive(type)
        setPersisted(persistConfig, type)
        onMetricsTypeChange(type)
      }
    }
  }, [])

  return (
    <I18n>
      {({ /* i18n */ }) => (
        <>
          <Sidebar.List>
            <Sidebar.ListItem
              isActive={active === MetricsType.Completed}
              onClick={handleSetActive(MetricsType.Completed, active === MetricsType.Completed)}
            >
              <ActionViewOutline small />
              <Sidebar.Link disabled={active === MetricsType.Completed}>Actions <em>Closed</em></Sidebar.Link>
            </Sidebar.ListItem>
            <Sidebar.ListItem
              isActive={active === MetricsType.Opened}
              onClick={handleSetActive(MetricsType.Opened, active === MetricsType.Opened)}
            >
              <ActionAddOutline small />
              <Sidebar.Link disabled={active === MetricsType.Opened}>Actions <em>Created</em></Sidebar.Link>
            </Sidebar.ListItem>
          </Sidebar.List>
        </>
      )}
    </I18n>
  )
}
